import React from "react";
import SEO from "../components/SEO";
import Hero from "../components/Hero";
import FeaturedDestinations from "../components/FeaturedDestinations";
import CountryMarquee from "../components/CountryMarquee";
import StoryTeasers from "../components/StoryTeasers";
import NewsletterSection from "../components/NewsletterSection";
import ShareButtons from "../components/ShareButtons";

export default function Home() {
  return (
    <main data-testid="home-page">
      <SEO
        title="Travel stories from the slow road"
        description="An editorial travel journal by Ashwini & Hemant Parulkar. Slow travel, long-form essays, and photographs from Italy, Scotland, Paris, Mauritius, Ecuador, Sri Lanka, and beyond."
        path="/"
      />
      <Hero />
      <FeaturedDestinations />
      <CountryMarquee />
      <StoryTeasers />
      <NewsletterSection />
      <section aria-label="Share this site" className="bg-[#FDFBF7] pb-20 -mt-4">
        <div className="max-w-5xl mx-auto px-6 lg:px-10 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 pt-10 border-t border-stone-200">
          <p className="kicker text-stone-500">Know someone who'd love Globezing?</p>
          <ShareButtons
            title="Globezing — travel stories from the slow road"
            description="An editorial journal of slow travel by Ashwini & Hemant Parulkar."
          />
        </div>
      </section>
    </main>
  );
}
